import { createContext, useContext } from 'react';

export interface AppConfig {
  /** Google OAuth Client ID. `null` = feature desativada no backend. */
  google_client_id: string | null;
  /** Google Maps JS API key. `null` = mapa desativado (Home cai no fallback de lista). */
  google_maps_api_key: string | null;
}

const DEFAULT_CONFIG: AppConfig = {
  google_client_id: null,
  google_maps_api_key: null
};

export const AppConfigContext = createContext<AppConfig>(DEFAULT_CONFIG);

export function useAppConfig(): AppConfig {
  return useContext(AppConfigContext);
}

/**
 * Busca config do backend antes do app montar. Falha silenciosa retorna
 * config default (Google desativado, login só por email/senha) — nunca
 * trava o boot porque o endpoint é não-crítico.
 */
export async function fetchAppConfig(): Promise<AppConfig> {
  try {
    const base = import.meta.env.VITE_API_BASE ?? '/api/v1';
    const resp = await fetch(`${base}/auth/config`, {
      headers: { Accept: 'application/json' }
    });
    if (!resp.ok) return DEFAULT_CONFIG;
    const data = await resp.json();
    return {
      google_client_id:
        typeof data?.google_client_id === 'string' && data.google_client_id
          ? data.google_client_id
          : null,
      google_maps_api_key:
        typeof data?.google_maps_api_key === 'string' && data.google_maps_api_key
          ? data.google_maps_api_key
          : null
    };
  } catch {
    return DEFAULT_CONFIG;
  }
}
